import {useDispatch} from "react-redux";
import {useRedPill} from "Hooks/api/useRedPill";
import {updateShopBalance, updateShopStatus} from "Redux/actions/shop";
import {IS_LOGGED_IN, SHOP_ENABLED} from "Setup/config";

/**
 * Fetches the shop only to learn whether it's real or the preview, and the balance
 * that comes with it — kept out of useShop for the same reason as useShopBalance.
 *
 * The notifications panel must not tell a player to redeem from a preview shop,
 * which sells nothing yet, so it needs isFakeShop on pages that never load the
 * shop. The items are left alone: storing them means transforming them against the
 * lobby, which is useShop's job, and /shop reloads them itself.
 */
export default function useShopStatus() {
    const dispatch = useDispatch();
    const {execute: getShop} = useRedPill("shop.getShop");

    const updateStatus = async () => {
        if (!IS_LOGGED_IN || !SHOP_ENABLED) return;

        const res = await getShop();
        if (res?.code === 200 && res.data) {
            const {shop: shopData, isFakeShop, balance} = res.data;
            dispatch(updateShopStatus(Boolean(isFakeShop)));

            // Same fallback as useShop: the balance may only be on the player.
            const knownBalance = balance ?? shopData?.player?.pointsBalance ?? null;
            if (knownBalance !== null) {
                dispatch(updateShopBalance(knownBalance, shopData?.abbreviation));
            }
        }
    };

    return {updateStatus};
}
